var map = {
	"./": [
		"L8Y5",
		0,
		18
	],
	"./404": [
		"Cy/J",
		10
	],
	"./404/": [
		"Cy/J",
		10
	],
	"./404/index": [
		"Cy/J",
		10
	],
	"./404/index.vue": [
		"Cy/J",
		10
	],
	"./authLogin": [
		"VbUl",
		0,
		16
	],
	"./authLogin/": [
		"VbUl",
		0,
		16
	],
	"./authLogin/index": [
		"VbUl",
		0,
		16
	],
	"./authLogin/index.vue": [
		"VbUl",
		0,
		16
	],
	"./bh": [
		"dRo0",
		0,
		15
	],
	"./bh/": [
		"dRo0",
		0,
		15
	],
	"./bh/index": [
		"dRo0",
		0,
		15
	],
	"./bh/index.vue": [
		"dRo0",
		0,
		15
	],
	"./curriculum": [
		"9rcM",
		0,
		14
	],
	"./curriculum/": [
		"9rcM",
		0,
		14
	],
	"./curriculum/index": [
		"9rcM",
		0,
		14
	],
	"./curriculum/index.vue": [
		"9rcM",
		0,
		14
	],
	"./dszt": [
		"ngTz",
		0,
		2
	],
	"./dszt/": [
		"ngTz",
		0,
		2
	],
	"./dszt/index": [
		"ngTz",
		0,
		2
	],
	"./dszt/index.vue": [
		"ngTz",
		0,
		2
	],
	"./events": [
		"amIh",
		0,
		8
	],
	"./events/": [
		"amIh",
		0,
		8
	],
	"./events/index": [
		"amIh",
		0,
		8
	],
	"./events/index.vue": [
		"amIh",
		0,
		8
	],
	"./home": [
		"fL4P",
		1,
		0
	],
	"./home/": [
		"fL4P",
		1,
		0
	],
	"./home/index": [
		"fL4P",
		1,
		0
	],
	"./home/index.vue": [
		"fL4P",
		1,
		0
	],
	"./index": [
		"L8Y5",
		0,
		18
	],
	"./index.vue": [
		"L8Y5",
		0,
		18
	],
	"./loading": [
		"8SZo",
		0,
		17
	],
	"./loading/": [
		"8SZo",
		0,
		17
	],
	"./loading/index": [
		"8SZo",
		0,
		17
	],
	"./loading/index.vue": [
		"8SZo",
		0,
		17
	],
	"./login": [
		"q8bm",
		0,
		13
	],
	"./login/": [
		"q8bm",
		0,
		13
	],
	"./login/index": [
		"q8bm",
		0,
		13
	],
	"./login/index.vue": [
		"q8bm",
		0,
		13
	],
	"./news": [
		"8Ffy",
		0,
		4
	],
	"./news/": [
		"8Ffy",
		0,
		4
	],
	"./news/index": [
		"8Ffy",
		0,
		4
	],
	"./news/index.vue": [
		"8Ffy",
		0,
		4
	],
	"./notice": [
		"ZvSq",
		0,
		12
	],
	"./notice/": [
		"ZvSq",
		0,
		12
	],
	"./notice/index": [
		"ZvSq",
		0,
		12
	],
	"./notice/index.vue": [
		"ZvSq",
		0,
		12
	],
	"./plan": [
		"R4qy",
		0,
		5
	],
	"./plan/": [
		"R4qy",
		0,
		5
	],
	"./plan/index": [
		"R4qy",
		0,
		5
	],
	"./plan/index.vue": [
		"R4qy",
		0,
		5
	],
	"./play": [
		"vT5g",
		0,
		9
	],
	"./play/": [
		"vT5g",
		0,
		9
	],
	"./play/index": [
		"vT5g",
		0,
		9
	],
	"./play/index.vue": [
		"vT5g",
		0,
		9
	],
	"./routerLink": [
		"ww4c",
		0,
		6
	],
	"./routerLink/": [
		"ww4c",
		0,
		6
	],
	"./routerLink/index": [
		"ww4c",
		0,
		6
	],
	"./routerLink/index.vue": [
		"ww4c",
		0,
		6
	],
	"./school": [
		"CDwT",
		0,
		11
	],
	"./school/": [
		"CDwT",
		0,
		11
	],
	"./school/index": [
		"CDwT",
		0,
		11
	],
	"./school/index.vue": [
		"CDwT",
		0,
		11
	],
	"./sqyr": [
		"BAYA",
		0,
		3
	],
	"./sqyr/": [
		"BAYA",
		0,
		3
	],
	"./sqyr/index": [
		"BAYA",
		0,
		3
	],
	"./sqyr/index.vue": [
		"BAYA",
		0,
		3
	],
	"./work": [
		"o+uO",
		0,
		7
	],
	"./work/": [
		"o+uO",
		0,
		7
	],
	"./work/index": [
		"o+uO",
		0,
		7
	],
	"./work/index.vue": [
		"o+uO",
		0,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9GPY";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/view lazy ^\.\/.*$
// module id = 9GPY
// module chunks = 20